import React from 'react';

const BannerPage = React.lazy(() => import('pages/Banner/BannerPage'));
const BannerAddPage = React.lazy(() => import('pages/Banner/BannerAddPage'));

const BannerRoute = [
  {
    path: '/banner',
    exact: true,
    name: 'Danh sách banner',
    function: 'CMS_BANNER_VIEW',
    component: BannerPage,
  },
  {
    path: '/banner/add',
    exact: true,
    name: 'Thêm mới banner',
    function: 'CMS_BANNER_ADD',
    component: BannerAddPage,
  },
  {
    path: '/banner/edit/:banner_id',
    exact: true,
    name: 'Chỉnh sửa banner',
    function: 'CMS_BANNER_EDIT',
    component: BannerAddPage,
  },
  {
    path: '/banner/detail/:banner_id',
    exact: true,
    name: 'Chi tiết banner',
    function: 'CMS_BANNER_VIEW',
    component: BannerAddPage,
  },
];

export default BannerRoute;
